import React from 'react';
import { GenerationProgressStrip, type GenerationProgressStripProps } from './GenerationProgress';
import { useGenerationHeartbeat } from '../../store/generationHeartbeat';

/**
 * `GenerationProgressStrip` for a live run card. It subscribes to the run's
 * server heartbeat ITSELF (`generationHeartbeats[runId]`, re-stamped every
 * ~30s by the job worker) so the beat reaches the stall detector without
 * living on the run object: the runs in `siteRag.activeGenerations` keep
 * their identity across heartbeat-only ticks, and nothing memoised on them
 * — the whole site page — recomputes for a value only this strip reads.
 *
 * Use this from list/map render sites (where a hook cannot be called); a
 * top-level host can call `useGenerationHeartbeat` and pass `heartbeatAt`
 * to the plain strip directly.
 */
export const InflightRunProgressStrip: React.FC<
  Omit<GenerationProgressStripProps, 'heartbeatAt'> & { runId: string }
> = ({ runId, ...props }) => {
  const heartbeatAt = useGenerationHeartbeat(runId);
  return <GenerationProgressStrip {...props} heartbeatAt={heartbeatAt} />;
};
